export default __webpack_public_path__ + "static/MineralSwimV2_Carton+ControlUnit+PRO-61db47e8ce5230fae2a11b1a4481fcd8.png";